<div class="symbols-title-row">
  <h3 class="mb-0"><b>Cross-connects and LOAs</b></h3>
  <div *ngIf="isMckayUser" class="company-picker">
    <span class="company-picker-label">Client</span>
    <p-dropdown (onChange)="loadClientsLoas()" [(ngModel)]="selectedClientSugarUuid"
                [filter]="true"
                [options]="listClientsForClientDropDown"
                [showClear]="true"
                placeholder="Choose an account"></p-dropdown>
  </div>
</div>

<div *ngIf="isMckayUser && selectedClientSugarUuid && !hasSugarUuid(selectedClientSugarUuid.name)"
     class="alert alert-warning alert-dismissible fade show">
  Uuid not found for company.
</div>

<div *ngIf="showContactsTable()" class="contact-section">
  <div class="symbols-title-row loa-section-title">
    <h3 class="mb-0"><b>Contact Emails by continent</b></h3>
  </div>
  <div class="alert alert-info">
    <i class="pi pi-info-circle mr-2"></i>
    List all contact emails McKay Brothers or Quincy Data should use in LOA, continent by continent.
    <span *ngIf="!isOnlyFinanceUser()">Click a cell to edit. Type an email and press Enter or Space to add it.</span>
  </div>

  <div *ngIf="error" class="alert alert-danger alert-dismissible">
    <button (click)="error = false" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
    {{ errorMessage }}
  </div>
  <div *ngIf="success" class="alert alert-success alert-dismissible">
    <button (click)="success = false" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
    <div *ngFor="let msg of successMessages">{{ msg }}</div>
  </div>
  <div *ngIf="acknowledgeDomainError" class="alert alert-danger alert-dismissible">
    <button (click)="acknowledgeDomainError = false" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
    {{ acknowledgeDomainErrorMessage }}
  </div>

  <div class="symbols-market-table">
    <p-table #contactsTable [value]="contactsByContinentList" dataKey="continent">
      <ng-template pTemplate="header">
        <tr>
          <th class="continent-col">Continent</th>
          <th *ngIf="selectedClient?.sugarMckayStatus !== null">
            Emails for BW service
            <span *ngIf="!isOnlyFinanceUser()" class="editable-hint">click to edit</span>
          </th>
          <th *ngIf="selectedClient?.sugarQuincyStatus !== null">
            Emails for MD service
            <span *ngIf="!isOnlyFinanceUser()" class="editable-hint">click to edit</span>
          </th>
        </tr>
      </ng-template>
      <ng-template let-contactsByContinent pTemplate="body">
        <tr>
          <td class="continent-cell">
            <span class="continent-code">{{ contactsByContinent.continent }}</span>
          </td>

          <td *ngIf="selectedClient?.sugarMckayStatus !== null"
              pEditableColumn [pEditableColumnDisabled]="isOnlyFinanceUser()">
            <p-cellEditor *ngIf="!isOnlyFinanceUser()">
              <ng-template pTemplate="input">
                <p-chips [(ngModel)]="contactsByContinent.emailsBWList"
                         placeholder="Type an email and press Enter to save"
                         [addOnBlur]="true"
                         [allowDuplicate]="false"
                         separator=" "
                         (keydown.enter)="saveEmails(contactsByContinent, 'bw')"
                         class="chips-input">
                </p-chips>
                <div class="edit-actions">
                  <button (click)="$event.stopPropagation(); saveEmails(contactsByContinent, 'bw')"
                          class="btn-save" type="button">
                    <i class="pi pi-check"></i> Save
                  </button>
                  <button (click)="$event.stopPropagation(); cancelEdit(contactsByContinent, 'bw')"
                          class="btn-cancel" type="button">
                    <i class="pi pi-times"></i> Cancel
                  </button>
                </div>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="email-output">
                  <span *ngFor="let email of contactsByContinent.emailsBWList" class="email-chip">{{ email }}</span>
                  <span *ngIf="!contactsByContinent.emailsBWList?.length" class="add-hint">
                    <i class="pi pi-plus-circle"></i> Click to add
                  </span>
                </div>
              </ng-template>
            </p-cellEditor>
            <div *ngIf="isOnlyFinanceUser()" class="email-output">
              <span *ngFor="let email of contactsByContinent.emailsBWList" class="email-chip">{{ email }}</span>
              <span *ngIf="!contactsByContinent.emailsBWList?.length" class="text-muted">-</span>
            </div>
          </td>

          <td *ngIf="selectedClient?.sugarQuincyStatus !== null"
              pEditableColumn [pEditableColumnDisabled]="isOnlyFinanceUser()">
            <p-cellEditor *ngIf="!isOnlyFinanceUser()">
              <ng-template pTemplate="input">
                <p-chips [(ngModel)]="contactsByContinent.emailsMDList"
                         placeholder="Type an email and press Enter to save"
                         [addOnBlur]="true"
                         [allowDuplicate]="false"
                         separator=" "
                         (keydown.enter)="saveEmails(contactsByContinent, 'md')"
                         class="chips-input">
                </p-chips>
                <div class="edit-actions">
                  <button (click)="$event.stopPropagation(); saveEmails(contactsByContinent, 'md')"
                          class="btn-save" type="button">
                    <i class="pi pi-check"></i> Save
                  </button>
                  <button (click)="$event.stopPropagation(); cancelEdit(contactsByContinent, 'md')"
                          class="btn-cancel" type="button">
                    <i class="pi pi-times"></i> Cancel
                  </button>
                </div>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="email-output">
                  <span *ngFor="let email of contactsByContinent.emailsMDList" class="email-chip">{{ email }}</span>
                  <span *ngIf="!contactsByContinent.emailsMDList?.length" class="add-hint">
                    <i class="pi pi-plus-circle"></i> Click to add
                  </span>
                </div>
              </ng-template>
            </p-cellEditor>
            <div *ngIf="isOnlyFinanceUser()" class="email-output">
              <span *ngFor="let email of contactsByContinent.emailsMDList" class="email-chip">{{ email }}</span>
              <span *ngIf="!contactsByContinent.emailsMDList?.length" class="text-muted">-</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<div class="symbols-title-row loa-section-title" *ngIf="filteredXcoLoaList && filteredXcoLoaList.length">
  <h3 class="mb-0"><b>Cross-connect list</b>
    <span class="symbols-table-count">{{ records }} result{{ records !== 1 ? 's' : '' }}</span>
  </h3>
</div>
<div class="symbols-market-table" *ngIf="xcoLoaList && xcoLoaList.length">
  <p-table #dataTableLoas [columns]="cols"
           [globalFilterFields]="['xcoId', 'loaStatus', 'loaContinent','loaService','serviceAbrv', 'loaHandoff', 'dataCenterRef', 'serviceAbrv']"
           [paginator]="true"
           [rows]="100" [tableStyle]="{'table-layout':'auto'}" [value]="filteredXcoLoaList"
           exportFilename="{{csvFilename}}"
           id="downLoaded-documents-list-table">
    <ng-template let-loa pTemplate="caption">
      <div class="loa-filter-bar">
        <div class="search-wrapper">
          <i class="fa fa-search search-icon"></i>
          <input class="form-control search-input" [(ngModel)]="globalFilter" (input)="applyFiltersOnDataTableItem()"
                 placeholder="Search" type="text">
        </div>
        <p-dropdown class="loa-service-filter" [(ngModel)]="loaFilterCriteria.serviceAbrv" (ngModelChange)="filter()"
                    [options]="serviceAbrvItems">
        </p-dropdown>
        <button (click)="resetFilters()" class="btn-reset-filters" id="reset_button" type="button">
          <i class="fa fa-refresh"></i> Reset
        </button>
        <span class="loa-filter-spacer"></span>
        <button (click)="exportToCsv()" class="btn-csv-export" type="button">
          <i class="fa fa-download"></i> Download csv
        </button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of cols" [pSortableColumnDisabled]="!col.sortable"
            [pSortableColumn]="col.field"
            class="p-sortable-column ng-star-inserted">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>
    <ng-template let-xcoLoa pTemplate="body">
      <tr [pSelectableRow]="xcoLoa">
        <td>
          <a class="xco-link" *roles="['ROLE_MCKAY']" [href]="loaUrl + '/#/xco-edit/' + xcoLoa.xcoUuid" target="_blank">
            {{ xcoLoa.xcoId }}
          </a>
          <ng-container *roles="['ROLE_CLIENT']">
            {{ xcoLoa.xcoId }}
          </ng-container>
        </td>
        <td>
          {{ xcoLoa?.loaStatus === 'Sent' ? 'Sent ' + xcoLoa?.loaSentDate : xcoLoa?.loaStatus || '' }}
        </td>
        <td class="mail-recipients-cell">
          <ul *ngIf="xcoLoa.mailRecipients && xcoLoa.mailRecipients.length > 0" class="mail-recipients-list">
            <li *ngFor="let recipient of xcoLoa.mailRecipients">{{ recipient }}</li>
          </ul>
        </td>
        <td>
          <span [pTooltip]="technicalPopService.getCageTooltip(xcoLoa.technicalPop)">{{ xcoLoa.pop }}</span>
        </td>
        <td class="contracts-cell">
          <ul class="contracts-list">
            <li *ngFor="let contract of xcoLoa.contracts">
              <a class="contract-link" *roles="['ROLE_MCKAY']" [href]="getProjectLink(contract)">
                {{ contract.name }}
              </a>
              <span *roles="['ROLE_CLIENT']">{{ contract.name }}</span>
            </li>
          </ul>
        </td>
        <td class="num-cell-narrow">
          {{ xcoLoa.rebillingStatus | titlecase }}
        </td>
        <td class="num-cell-narrow">
          {{ xcoLoa.loaHandoff }}
        </td>
        <td>
          {{ xcoLoa.dataCenterRef }}
        </td>
        <td>
          <textarea (focusin)="xcoLoa.textAriaRows = 4" (focusout)="changeClientRef(xcoLoa)"
                    (keydown.enter)="$event.preventDefault(); changeClientRef(xcoLoa)"
                    [(ngModel)]="xcoLoa.newClientRef"
                    [rows]="xcoLoa.textAriaRows"
                    class="form-control client-ref-input" id="clientRef"
                    maxlength="64"
                    name="publicDescription">
          </textarea>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      {{ records }} results
    </ng-template>
  </p-table>
</div>
